<template>
  <div class="page">
    <div class="bg-content padding15">
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="录音员">
              <el-select v-model="search.recorderId" style="width: 100%;" placeholder="请选择录音员" clearable filterable>
                <el-option
                  v-for="item in recorderOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关键词">
              <el-select v-model="search.filedId" style="width: 100%;" placeholder="请选择关键词" clearable filterable>
                <el-option
                  v-for="item in filedOperate"
                  :key="item.id"
                  :label="item.description"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="音频名称">
              <el-input clearable v-model="search.name" placeholder="请输入音频名称"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="添加时间">
              <el-date-picker v-model="search.timeFrom" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker v-model="search.timeTo" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
            </el-form-item>
          </el-col>
          <div class="padding15-tb text right">
            <el-button type="primary" size="small" @click="getData(1)"><i class="fa fa-search"></i>搜索</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="addFiledVoiceButton()">添加音频</el-button>
      </p>
    </div>
    <div class="padding15">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        :span-method="arraySpanMethod"
        border
        stripe
        style="width: 100%">
        <el-table-column
          prop="filedName"
          align="center"
          label="模板关键字">
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="音频名称">
        </el-table-column>
        <el-table-column
          prop="recorder"
          align="center"
          label="录音员">
          <template slot-scope="scope">
              <span v-if="scope.row.recorder">{{ scope.row.recorder }}</span>
              <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="添加时间">
        </el-table-column>
        <el-table-column
          prop="address"
          align="center"
          label="地址">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.showAddress === false" @click="showButton(scope)">录音查看</el-button>
            <div class="audio" :id="'myAudio'+scope.$index" v-if="scope.row.showAddress === true" v-loading="scope.row.voiceLoading" element-loading-spinner="el-icon-loading"
              element-loading-background="#F5F7FA" style="height: 30px;width: 100%;outline: none;">
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editTemplateFiledButton(scope.row)" style="color: #816DF1 !important;"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteTemplateFiledButton(scope.row)" style="color: #F57E50 !important;"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFiledVoiceDialog"
      center
      width="40%">
      <el-form label-width="100px">
        <el-form-item label="关键字">
          <el-select v-model="req.filedId" style="width: 80%;" placeholder="请选择" clearable  filterable>
            <el-option
              v-for="item in filedOperate"
              :key="item.id"
              :label="item.description"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="录音员">
          <el-input v-model="req.recorder" placeholder="请输入内容" style="width:80%"></el-input>
        </el-form-item> -->
        <el-form-item label="录音员">
          <el-select v-model="req.recorderId" placeholder="请选择录音员"  style="width: 80%;" filterable>
            <el-option
              v-for="item in recorderOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="音频名称">
          <el-input v-model="req.name" placeholder="请输入内容" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="音频">
          <el-select v-model="req.sftpAddress" @change="addressChange()" placeholder="请选择音频" style="width:80%">
              <el-option
                v-for="item in aiFileList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="音频试听">
          <div v-if="req.sftpAddress" v-loading="voiceLoading" class="audio" id="myAudioNew" element-loading-spinner="el-icon-loading"
            element-loading-background="#F5F7FA" style="height: 30px;width: 80%;outline: none;">
          </div>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="录音">
          <el-button type="primary" @click="onStartVoice" round>开始</el-button>
          <el-button type="warning" @click="onEndVoice" round>结束</el-button>
          <el-button type="success" @click="onPlayAudio" round>试听</el-button>
          <el-button type="danger" @click="uploadFile" round>上传</el-button>
          <el-upload class="upload-demo"
            :on-change="fileChanged"
            multiple
            :limit="1"
            ref="upload" action='#' accept=".wav,.mp3,.m4a"
            :auto-upload="false"
            :show-file-list="false"
            :file-list="fileList.length===0?[]:fileList"
            style="float: left;">
            <el-button size="small" type="warning" @click="upload()" round>本地录音上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">请上传本地录音</div> -->
            &nbsp;
          </el-upload>
          <div class="pd recpower">
            <div style="width:80%;background:rgb(37 47 74);font-size: 18px;text-align: center;position:relative;top:5px">
              {{str}}
            </div>
            <br/>
          </div>
          <div class="record-play" v-show="isFinished">
            <h2>Current voice player is:</h2>
            <audio style="width: 80%;" id="audioVoice"  controls autoplay></audio>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFiledVoiceDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add" size="small" plain>保 存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import Record from '../../../../utils/record-sdk';

export default {
  inject: ['reload'],
  data() {
    return {
      loading: true,
      list: [],
      pageData: {},
      sort: {
        order: '',
        sort: ''
      },
      defaultSort: {
        order: 'id',
        sort: 'asc'
      },
      companyId: null,
      groupId: null,
      dialogTitle: null,
      filedOperate: [],
      addFiledVoiceDialog: false,
      req: {
        id: null,
        companyId: null,
        groupId: null,
        recorderId: null,
        name: null,
        filedId: null,
        sftpAddress: null
      },
      search: {
        filedId: null,
        name: null,
        recorderId: null,
        timeFrom: null,
        timeTo: null
      },
      spanArr: '',
      isFinished: false,
      recorder: new Record(),
      hour: 0, // 定义时，分，秒，毫秒并初始化为0；
      minute: 0,
      ms: 0,
      second: 0, // 秒
      time: '',
      str: '00:00:00',
      aiFileList: [],
      voiceLoading: false,
      fileList: [],
      recorderOption: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      const filedId = sessionStorage.getItem('filedId');
      if (filedId) {
        this.search.filedId = Number(filedId);
      }
      this.companyId = null;
      this.$ajax({
        url: '/template/getFiledListByCompanyId',
        params: { companyId: '' }
      }).then((res) => {
        this.filedOperate = res.data;
      });
      this.getRecorderList();
      this.getData(1);
    });
  },
  methods: {
    getSpanArr(data) {
      this.spanArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push([1, 1]);
          this.onepos = 0;
          this.towpos = 0;
        } else if (data[i].filedName === data[i - 1].filedName) { // 判断当前元素与上一个元素是否相同
          this.spanArr[this.onepos][0] += 1;
          this.spanArr.push([0, 1]);
          this.towpos = i;
        } else {
          this.spanArr.push([1, 1]);
          this.onepos = i;
          this.towpos = i;
        }
      }
    },
    // 合并
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        const rows = this.spanArr[rowIndex][columnIndex];
        const cols = rows > 0 ? 1 : 0;
        return { rowspan: rows, colspan: cols };
      }
      return { rowspan: 1, colspan: 1 };
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    add() {
      if (!this.req.filedId) {
        this.$message.error('请选择关键字');
        return;
      }
      if (!this.req.recorderId) {
        this.$message.error('录音员不能为空');
        return;
      }
      if (!this.req.name) {
        this.$message.error('录音名称不能为空');
        return;
      }
      if (!this.req.sftpAddress) {
        this.$message.error('请选择音频');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        url: '/filedVoice/updateOrInsertFiledVoice',
        prompt: true,
        method: 'POST',
        data: this.req
      }).then(() => {
        this.addFiledVoiceDialog = false;
        loading.close();
        this.getData(1);
      }).finally(() => {
        loading.close();
      });
    },
    upload() {
      this.fileList = [];
    },
    // 上传音频
    fileChanged(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.aiFileList = [];
      this.fileList = fileList;
      const FileExt = file.name.replace(/.+\./, '').toLowerCase();
      const wavFlag = ['wav'].includes(FileExt);
      const mp3Flag = ['mp3'].includes(FileExt);
      const m4aFlag = ['m4a'].includes(FileExt);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!wavFlag && !mp3Flag && !m4aFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
      }
      if (!isLt5M) {
        this.$message.error('上传的文件大小不能超过 5MB!');
        this.fileList = [];
        loading.close();
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('type', 2);
      if ((wavFlag || mp3Flag || m4aFlag) && isLt5M) {
        this.$ajax({
          url: '/scene/recordUpload',
          method: 'POST',
          prompt: true,
          contentType: 'multipart/form-data',
          data: formData
        }).then((res) => {
          if (res.data) {
            res.data.forEach((element) => {
              const ai = {
                value: element,
                label: element.substring(element.lastIndexOf('/') + 1)
              };
              this.aiFileList.push(ai);
            });
          }
          loading.close();
        });
      }
      return (wavFlag || mp3Flag || m4aFlag) && isLt5M;
    },
    uploadFile() {
      this.aiFileList = [];
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const blob = this.recorder.getBlob();
      const fileName = `${new Date().getTime()}.wav`;
      const files = new window.File([blob], fileName);
      const formData = new FormData();
      formData.append('file', files);
      formData.append('type', 2);
      this.$ajax({
        url: '/scene/recordUpload',
        method: 'POST',
        prompt: true,
        contentType: 'multipart/form-data',
        data: formData
      }).then((res) => {
        console.warn(res);
        res.data.forEach((element) => {
          const ai = {
            value: element,
            label: element.substring(element.lastIndexOf('/') + 1)
          };
          this.aiFileList.push(ai);
        });
        loading.close();
      });
    },
    showButton(scope) {
      scope.row.showAddress = true;
      this.auditionVoice(scope.row, scope.$index);
    },
    // 录音试听
    auditionVoice(row, index) {
      this.$set(row, 'voiceLoading', true);
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': row.sftpAddress }
      }).then((re) => {
        const blob = new Blob([re.data]);
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.controlsList = 'nodownload';
        frameAudio.style = 'height: 30px;width: 60%;outline: none;';
        const bodyFa = document.getElementById(`myAudio${index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(row, 'voiceLoading', false);
      });
    },
    addressChange() {
      this.voiceLoading = true;
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': this.req.sftpAddress }
      }).then((re) => {
        document.getElementById('myAudioNew').innerHTML = '';
        const blob = new Blob([re.data]);
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.controlsList = 'nodownload';
        frameAudio.style = 'height: 30px;width: 80%;outline: none;';
        const bodyFa = document.getElementById('myAudioNew');
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.voiceLoading = false;
      });
    },
    addFiledVoiceButton() {
      this.dialogTitle = '添加音频';
      this.req.id = null;
      this.req.companyId = this.companyId;
      this.req.groupId = this.groupId;
      this.req.recorderId = null;
      this.req.name = null;
      this.req.filedId = null;
      this.req.sftpAddress = null;
      this.addFiledVoiceDialog = true;
    },
    editTemplateFiledButton(row) {
      console.warn(row);
      this.dialogTitle = '编辑音频';
      this.req.id = row.id;
      this.req.companyId = row.companyId;
      this.req.groupId = row.groupId;
      this.req.recorderId = row.recorderId;
      this.req.name = row.name;
      this.req.filedId = Number(row.filedId);
      this.req.sftpAddress = row.sftpAddress;
      this.addFiledVoiceDialog = true;
      this.addressChange();
    },
    getData(page) {
      this.aiFileList = [];
      this.loading = true;
      this.$ajax({
        url: '/filedVoice/getFiledVoiceList',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = res.data.list;
        this.getSpanArr(this.list);
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.loading = false;
        this.list.forEach((element) => {
          if (element.sftpAddress) {
            const ai = {
              value: element.sftpAddress,
              label: element.sftpAddress.substring(element.sftpAddress.lastIndexOf('/') + 1)
            };
            this.aiFileList.push(ai);
          }
        });
      });
    },
    reset() {
      this.search.filedId = null;
      this.search.name = null;
      this.search.recorderId = null;
      this.search.timeFrom = null;
      this.search.timeTo = null;
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'page': page,
        'limit': this.pageData.pageSize || 20,
        'order': this.sort.order || this.defaultSort.order,
        'sort': this.sort.sort || this.defaultSort.sort,
        'filedId': this.search.filedId,
        'name': this.search.name,
        'recorderId': this.search.recorderId,
        'timeFrom': this.search.timeFrom,
        'timeTo': this.search.timeTo
      };
      return req;
    },
    getFiledListByCompanyId() {
      this.$ajax({
        url: '/template/getFiledListByCompanyId',
        params: { 'companyId': this.companyId }
      }).then((res) => {
        console.warn(res);
        this.filedOperate = res.data;
      });
    },
    // 开始计时
    timeStart() {
      this.time = setInterval(this.timer(), 50);
    },
    timer() { // 定义计时函数
      this.ms = this.ms + 50; // 毫秒
      if (this.ms >= 1000) {
        this.ms = 0;
        this.second = this.second + 1; // 秒
      }
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1; // 分钟
      }
      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1; // 小时
      }
      //
      this.str = `${this.toDub(this.hour)}:${this.toDub(this.minute)}:${this.toDub(this.second)}`;/* +""+this.toDubms(this.ms)+"毫秒" */
      // document.getElementById('mytime').innerHTML=h+"时"+m+"分"+s+"秒"+ms+"毫秒";
    },
    // 补零操作
    toDub(n) { // 补0操作
      if (n < 10) {
        return `0${n}`;
      }
      return `${n}`;
    },
    // 时间重置
    timeReset() {
      clearInterval(this.time);
      // this.hour =0
      this.minute = 0;
      this.ms = 0;
      this.second = 0;
      this.str = '00:00:00';
    },
    // 开始录音
    onStartVoice() {
      this.timeReset();
      this.onStopAudio();
      this.isFinished = false;
      this.time = setInterval(this.timer, 50);
      this.recorder.startRecord({
        success: (res) => {
          console.warn(res);
          this.isVoice = true;
        },
        error: (e) => {
          this.isVoice = false;
          this.$toast(e);
        }
      });
    },
    // 结束录音
    onEndVoice() {
      clearInterval(this.time);
      this.isFinished = false;
      this.recorder.stopRecord({
        success: (res) => {
          this.isVoice = false;
          // 此处可以获取音频源文件(res)，用于上传等操作
          console.warn('音频源文件', res);
        },
        error: (e) => {
          console.warn(e);
          this.isVoice = false;
        }
      });
    },

    // 播放录音
    onPlayAudio() {
      this.isVoice = false;
      this.isFinished = true;
      this.audio = document.getElementById('audioVoice');
      this.recorder.play(this.audio);
    },

    // 停止播放录音
    onStopAudio() {
      this.recorder.clear(this.audio);
    },
    deleteTemplateFiledButton(row) {
      this.$confirm('确定删除该模板录音?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/filedVoice/deleteTemplateFiled',
          prompt: true,
          method: 'POST',
          data: {
            'id': row.id
          }
        }).then(() => {
          this.getData(1);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 获取录音员
    getRecorderList() {
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: {
          status: 1
        }
      }).then((res) => {
        this.recorderOption = res.data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/system/keywordAudio/filed_voice.vue